var map = {
	"./img.png": 1974,
	"./img1.png": 1723,
	"./img10.png": 1724,
	"./img2.png": 1725,
	"./img3.png": 1726,
	"./img4.png": 1727,
	"./img5.png": 1728,
	"./img6.png": 1729,
	"./img7.png": 1730,
	"./img8.png": 1731,
	"./img9.png": 1732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1973;